module.exports = __webpack_public_path__ + "static/media/DOGE.bfe942ea.svg";